import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import Container from './container';
import styles from './modal.css';

function callOrReturn(ctx) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof ctx === 'function' ? ctx.apply(void 0, args) : ctx;
}

function addClass(el, className) {
  var elClassName = el.className;

  if (" ".concat(elClassName, " ").includes(" ".concat(className, " "))) {
    el.className += " ".concat(className);
  }
}

function removeClass(el, className) {
  var elClassName = el.className;

  if (" ".concat(elClassName, " ").includes(" ".concat(className, " "))) {
    el.className = " ".concat(elClassName, " ").replace(" ".concat(className, " "), '').trim();
  }
}

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isShowing: false,
      mounted: false
    });

    _defineProperty(_assertThisInitialized(_this), "openHandler", function (e) {
      e.preventDefault();

      _this.openModal();

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "closeHandler", function (e) {
      e.preventDefault();

      _this.closeModal();

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (show) {
      var _this$props = _this.props,
          forceIsShowing = _this$props.forceIsShowing,
          onClose = _this$props.onClose,
          onOpen = _this$props.onOpen;

      if (show) {
        onOpen();
      } else {
        onClose();
      }

      if (typeof forceIsShowing === 'boolean') {
        return;
      }

      _this.setState(function (_ref) {
        var isShowing = _ref.isShowing;
        return {
          isShowing: show === undefined ? !isShowing : show
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      return _this.toggleModal(false);
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      return _this.toggleModal(true);
    });

    if (typeof props.forceIsShowing === 'boolean') {
      _this.state.isShowing = props.forceIsShowing;
    }

    if (!_this.domNode && typeof document !== 'undefined') {
      _this.domNode = document.createElement('div');
    }

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.appendChild(this.domNode);
      this.setState({
        mounted: true
      }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var forceIsShowing = _ref2.forceIsShowing;
      var isShowing = this.state.isShowing;

      if (forceIsShowing !== isShowing && typeof forceIsShowing === 'boolean') {
        this.setState({
          isShowing: forceIsShowing
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isShowing = this.state.isShowing;

      if (!prevState.isShowing && isShowing) {
        addClass(document.body, styles.noScroll);
      } else if (prevState.isShowing && !isShowing) {
        removeClass(document.body, styles.noScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      this.setState({
        mounted: false
      }, function () {
        return document.body.removeChild(_this2.domNode);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          content = _this$props2.content,
          children = _this$props2.children,
          rest = _objectWithoutProperties(_this$props2, ["content", "children"]);

      var _this$state = this.state,
          isShowing = _this$state.isShowing,
          mounted = _this$state.mounted;
      var renderProps = {
        close: this.closeModal,
        open: this.openModal
      };
      var renderedContent = callOrReturn(content, renderProps);
      var renderedChildren = callOrReturn(children, renderProps);

      var container = function container(containerChildren) {
        return React.createElement(Container, _extends({
          key: "portal",
          closeHandler: _this3.closeHandler,
          isShowing: isShowing
        }, rest), containerChildren);
      };

      if (renderedContent) {
        if (mounted) {
          return [createPortal(container(renderedContent), this.domNode), renderedChildren && cloneElement(renderedChildren, {
            key: 'portal-trigger'
          })];
        }

        return renderedChildren;
      } // The server needs to render a placeholder element here or else you get chaos!


      return React.createElement("div", null, mounted && createPortal(container(renderedChildren), this.domNode));
    }
  }]);

  return Modal;
}(Component);

_defineProperty(Modal, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  forceIsShowing: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
});

_defineProperty(Modal, "defaultProps", {
  children: null,
  content: undefined,
  forceIsShowing: undefined,
  onOpen: function onOpen() {},
  onClose: function onClose() {}
});

export { Modal as default };